module.exports = __webpack_public_path__ + "static/img/find_house.5ab7d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/aboutUs/find_house.png
// module id = JVSs
// module chunks = 30